import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const InitialCard = () => {
	const {t} = useTranslation()
	return (
		// <Card className="intake-programs">
		<Flex justify="space-between" align="center" style={{ height: '100%' }}>
			<Flex justify="space-between" vertical>
				<Flex vertical gap="small">
					<Title level={2} style={{ color: '#fff', marginBottom: 0 }}>
						{t('Admin.data.intakeProcess.letsExperience')}
					</Title>
					<Text
						style={{
							color: 'rgba(255, 255, 255, 0.9)',
							fontSize: 27,
							maxWidth: 600,
						}}>
						{t('Admin.data.intakeProcess.answerQuestions')}
					</Text>
				</Flex>
				{/* <Button onClick={() => handleGetStep('body-selection')}>
					Get Started
				</Button> */}
			</Flex>
		</Flex>
		// </Card>
	);
};

export default InitialCard;
